/**
 * Replaces items matched in the regex with new line
 *
 * @param {import('./index').WPWordCountSettings} settings The main settings object containing regular expressions
 * @param {string}                                text     The string being counted.
 *
 * @return {string} The manipulated text.
 */
export default function stripTags(settings, text) {
  return text.replace(settings.HTMLRegExp, '\n');
}
//# sourceMappingURL=stripTags.js.map